// UI string translations keyed by dot-separated paths. Larger pieces of
// content (project descriptions, privacy policies) live next to the data they
// belong to as bilingual { en, sv } objects resolved via pick().
export const translations = {
  en: {
    nav: {
      home: "Home",
      portfolio: "Projects",
      students: "Students",
      team: "Team",
      menu: "Menu",
    },
    lang: {
      label: "Language",
      en: "English",
      sv: "Svenska",
    },
    common: {
      learnMore: "Learn More",
      notPublic: "Not publicly available",
      visitWebsite: "Visit Website",
      youtubeChannel: "YouTube Channel",
      readThesis: "Read Thesis",
      createStory: "Create a Story",
    },
    footer: {
      location: "Lund, Sweden",
    },
    home: {
      tagline: "Fullstack applications & AI solutions",
      lead1:
        "We build custom software — web platforms, mobile apps, VR simulations and AI tools.",
      lead2: "Let's talk about what we can build together.",
      cta: "Get in touch",
      featured: "Featured Projects",
      viewAll: "View all projects",
      contact: "Contact",
      sayHello: "Say hello",
      contactLead:
        "Tell us about your project, your company, or your ideas — we'd love to hear from you.",
    },
    portfolio: {
      title: "Projects",
    },
    team: {
      title: "Team",
      coFounder: "Co-founder",
    },
    students: {
      title: "Student Projects",
      heading: "Database Evaluation",
      body: "Teodor and Axel studied systems science at LTU, Sweden, and worked with us to evaluate and research different database solutions. They compared our current implementation with Firebase to a regular MySQL solution and the project was carried out with great success.",
    },
    notFound: {
      title: "404 Not Found",
      body: "Seems like the page you are looking for is in another castle!",
    },
  },
  sv: {
    nav: {
      home: "Hem",
      portfolio: "Projekt",
      students: "Studenter",
      team: "Team",
      menu: "Meny",
    },
    lang: {
      label: "Språk",
      en: "English",
      sv: "Svenska",
    },
    common: {
      learnMore: "Läs mer",
      notPublic: "Inte offentligt tillgängligt",
      visitWebsite: "Besök webbplats",
      youtubeChannel: "YouTube-kanal",
      readThesis: "Läs uppsats",
      createStory: "Skapa en saga",
    },
    footer: {
      location: "Lund, Sverige",
    },
    home: {
      tagline: "Fullstack-applikationer & AI-lösningar",
      lead1:
        "Vi bygger skräddarsydd mjukvara — webbplattformar, mobilappar, VR-simuleringar och AI-verktyg.",
      lead2: "Låt oss prata om vad vi kan bygga tillsammans.",
      cta: "Hör av dig",
      featured: "Utvalda projekt",
      viewAll: "Visa alla projekt",
      contact: "Kontakt",
      sayHello: "Säg hej",
      contactLead:
        "Berätta om ditt projekt, ditt företag eller dina idéer — vi vill gärna höra från dig.",
    },
    portfolio: {
      title: "Projekt",
    },
    team: {
      title: "Team",
      coFounder: "Medgrundare",
    },
    students: {
      title: "Studentprojekt",
      heading: "Databasutvärdering",
      body: "Teodor och Axel läste systemvetenskap vid LTU och arbetade med oss för att utvärdera och undersöka olika databaslösningar. De jämförde vår nuvarande implementation med Firebase mot en vanlig MySQL-lösning, och projektet genomfördes med stor framgång.",
    },
    notFound: {
      title: "404 Hittades inte",
      body: "Sidan du letar efter verkar finnas i ett annat slott!",
    },
  },
};
